var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEdit = function SvgIconEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18h18V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 9a7.875 7.875 0 1 1-15.75 0 7.875 7.875 0 0 1 15.75 0",
    fill: "#787D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.228 11.97 6.03 9.773l4.547-4.547a1.525 1.525 0 0 1 2.15 0l.048.047c.592.59.592 1.56 0 2.151l-4.547 4.548zm-1.854-.344-1.099-1.1-.494 2.693 2.692-.494z",
    fill: "#FFF"
  }))));
};
export default SvgIconEdit;